module.exports = __webpack_public_path__ + "static/media/terms-banner-graphic.79232476.png";